import { gql } from '@apollo/client';

export const ADD_LINKED_INCIDENT = gql`
  mutation addLinkedIncident($input: AddLinkedIncidentInput!) {
    addLinkedIncident(input: $input) {
      errors
      incident {
        id
        incidentNumber
      }
    }
  }
`

//Example input:
// {
//   "input": {
//     "incidentId": ID,
//     "originatorId": ID,
//     "idToLink": ID
//   }
// }

